import { render, staticRenderFns } from "./clean-data-modal.vue?vue&type=template&id=80be719c"
import script from "./clean-data-modal.vue?vue&type=script&lang=js"
export * from "./clean-data-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports